module.exports = __webpack_public_path__ + "static/media/first-enterprise-plan.8e19d45f.png";